export default __webpack_public_path__ + "c682e00.png";